// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/reference/v1/reference.proto" (package "agency.reference.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * Reference is a globally addressable pointer to any referenceable entity.
 * It encodes protocol, kind, identity, and display metadata, and maps between
 * its canonical psref:/// form and external URIs.
 *
 * Canonical psref URI format: psref:///<kind-slug>?id=<id>[&version=<v>][&tenant=<t>][&ext=<extension>][&<extra>=<val>...]
 * kind-slug is the lowercase hyphenated name of ReferenceKind (e.g. "chat-message").
 * ext is a file extension without a leading dot (e.g. "png", "pdf"). MIME type is derived from it at parse time.
 *
 * @generated from protobuf message agency.reference.v1.Reference
 */
export interface Reference {
    /**
     * kind is the high-level category of the referenced entity. Required; UNSPECIFIED is not valid.
     *
     * @generated from protobuf field: agency.reference.v1.ReferenceKind kind = 1
     */
    kind: ReferenceKind;
    /**
     * id is the primary identifier of the referenced entity.
     *
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * ext is the file extension without a leading dot (e.g. "png", "pdf", "mp4").
     * MIME type is derived from this field at parse time and never stored in the URI.
     *
     * @generated from protobuf field: string ext = 3
     */
    ext: string;
    /**
     * type is the MIME type derived from ext at parse time (e.g. "image/png").
     * Never stored in the psref URI — computed only, not round-tripped.
     *
     * @generated from protobuf field: string type = 11
     */
    type: string;
    /**
     * version is an optional version or revision identifier.
     *
     * @generated from protobuf field: string version = 4
     */
    version: string;
    /**
     * tenant scopes the reference to a specific tenant.
     *
     * @generated from protobuf field: string tenant = 5
     */
    tenant: string;
    /**
     * title is the display text for the reference (link label).
     *
     * @generated from protobuf field: string title = 6
     */
    title: string;
    /**
     * description is the tooltip/hover text for the reference.
     *
     * @generated from protobuf field: string description = 7
     */
    description: string;
    /**
     * uri is the raw input URI as found in content (psref:///, http://, file://, etc.).
     *
     * @generated from protobuf field: string uri = 8
     */
    uri: string;
    /**
     * psref_uri is the canonical psref:/// form computed from structured fields.
     * Empty for purely external references that have no psref representation.
     *
     * @generated from protobuf field: string psref_uri = 9
     */
    psrefUri: string;
    /**
     * params holds additional open query parameters beyond the structural fields.
     *
     * @generated from protobuf field: map<string, string> params = 10
     */
    params: {
        [key: string]: string;
    };
}
/**
 * ParseReferenceRequest requests parsing of a URI string into a Reference.
 *
 * @generated from protobuf message agency.reference.v1.ParseReferenceRequest
 */
export interface ParseReferenceRequest {
    /**
     * @generated from protobuf field: string uri = 1
     */
    uri: string;
}
/**
 * ParseReferenceResponse returns the parsed Reference.
 *
 * @generated from protobuf message agency.reference.v1.ParseReferenceResponse
 */
export interface ParseReferenceResponse {
    /**
     * @generated from protobuf field: agency.reference.v1.Reference reference = 1
     */
    reference?: Reference;
}
/**
 * BuildReferenceRequest requests construction of a canonical psref_uri from a Reference.
 *
 * @generated from protobuf message agency.reference.v1.BuildReferenceRequest
 */
export interface BuildReferenceRequest {
    /**
     * @generated from protobuf field: agency.reference.v1.Reference reference = 1
     */
    reference?: Reference;
}
/**
 * BuildReferenceResponse returns the constructed canonical psref_uri.
 *
 * @generated from protobuf message agency.reference.v1.BuildReferenceResponse
 */
export interface BuildReferenceResponse {
    /**
     * @generated from protobuf field: string psref_uri = 1
     */
    psrefUri: string;
}
/**
 * ReferenceKind is the canonical high-level category of a referenced entity.
 * This is the source of truth — downstream schemas (TypeScript, etc.) are generated from this.
 *
 * @generated from protobuf enum agency.reference.v1.ReferenceKind
 */
export enum ReferenceKind {
    /**
     * @generated from protobuf enum value: REFERENCE_KIND_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: REFERENCE_KIND_PARTICIPANT = 1;
     */
    PARTICIPANT = 1,
    /**
     * @generated from protobuf enum value: REFERENCE_KIND_GROUP = 2;
     */
    GROUP = 2,
    /**
     * @generated from protobuf enum value: REFERENCE_KIND_GENERAL = 3;
     */
    GENERAL = 3,
    /**
     * @generated from protobuf enum value: REFERENCE_KIND_URI = 4;
     */
    URI = 4,
    /**
     * @generated from protobuf enum value: REFERENCE_KIND_FILE = 5;
     */
    FILE = 5,
    /**
     * @generated from protobuf enum value: REFERENCE_KIND_MEDIA = 6;
     */
    MEDIA = 6,
    /**
     * @generated from protobuf enum value: REFERENCE_KIND_CHAT_MESSAGE = 7;
     */
    CHAT_MESSAGE = 7,
    /**
     * @generated from protobuf enum value: REFERENCE_KIND_WORKSPACE = 8;
     */
    WORKSPACE = 8,
    /**
     * @generated from protobuf enum value: REFERENCE_KIND_THREAD = 9;
     */
    THREAD = 9,
    /**
     * @generated from protobuf enum value: REFERENCE_KIND_CONVERSATION = 10;
     */
    CONVERSATION = 10
}
// @generated message type with reflection information, may provide speed optimized methods
class Reference$Type extends MessageType<Reference> {
    constructor() {
        super("agency.reference.v1.Reference", [
            { no: 1, name: "kind", kind: "enum", T: () => ["agency.reference.v1.ReferenceKind", ReferenceKind, "REFERENCE_KIND_"], options: { "buf.validate.field": { enum: { notIn: [0] } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 3, name: "ext", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "32", pattern: "^[a-zA-Z0-9]*$" } } } },
            { no: 11, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-zA-Z0-9][a-zA-Z0-9!#$&\\-^_]*\\/[a-zA-Z0-9][a-zA-Z0-9!#$&\\-^_.+]*)?$" } } } },
            { no: 4, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128" } } } },
            { no: 5, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 6, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "1024" } } } },
            { no: 8, name: "uri", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "2048" } } } },
            { no: 9, name: "psref_uri", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } },
            { no: 10, name: "params", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value?: PartialMessage<Reference>): Reference {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.kind = 0;
        message.id = "";
        message.ext = "";
        message.type = "";
        message.version = "";
        message.tenant = "";
        message.title = "";
        message.description = "";
        message.uri = "";
        message.psrefUri = "";
        message.params = {};
        if (value !== undefined)
            reflectionMergePartial<Reference>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Reference): Reference {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.reference.v1.ReferenceKind kind */ 1:
                    message.kind = reader.int32();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* string ext */ 3:
                    message.ext = reader.string();
                    break;
                case /* string type */ 11:
                    message.type = reader.string();
                    break;
                case /* string version */ 4:
                    message.version = reader.string();
                    break;
                case /* string tenant */ 5:
                    message.tenant = reader.string();
                    break;
                case /* string title */ 6:
                    message.title = reader.string();
                    break;
                case /* string description */ 7:
                    message.description = reader.string();
                    break;
                case /* string uri */ 8:
                    message.uri = reader.string();
                    break;
                case /* string psref_uri */ 9:
                    message.psrefUri = reader.string();
                    break;
                case /* map<string, string> params */ 10:
                    this.binaryReadMap10(message.params, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap10(map: Reference["params"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Reference["params"] | undefined, val: Reference["params"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.reference.v1.Reference.params");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: Reference, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.reference.v1.ReferenceKind kind = 1; */
        if (message.kind !== 0)
            writer.tag(1, WireType.Varint).int32(message.kind);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* string ext = 3; */
        if (message.ext !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.ext);
        /* string version = 4; */
        if (message.version !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.version);
        /* string tenant = 5; */
        if (message.tenant !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.tenant);
        /* string title = 6; */
        if (message.title !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.title);
        /* string description = 7; */
        if (message.description !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.description);
        /* string uri = 8; */
        if (message.uri !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.uri);
        /* string psref_uri = 9; */
        if (message.psrefUri !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.psrefUri);
        /* map<string, string> params = 10; */
        for (let k of globalThis.Object.keys(message.params))
            writer.tag(10, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.params[k]).join();
        /* string type = 11; */
        if (message.type !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.reference.v1.Reference
 */
export const Reference = new Reference$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ParseReferenceRequest$Type extends MessageType<ParseReferenceRequest> {
    constructor() {
        super("agency.reference.v1.ParseReferenceRequest", [
            { no: 1, name: "uri", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "2048" } } } }
        ]);
    }
    create(value?: PartialMessage<ParseReferenceRequest>): ParseReferenceRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.uri = "";
        if (value !== undefined)
            reflectionMergePartial<ParseReferenceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ParseReferenceRequest): ParseReferenceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string uri */ 1:
                    message.uri = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ParseReferenceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string uri = 1; */
        if (message.uri !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.uri);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.reference.v1.ParseReferenceRequest
 */
export const ParseReferenceRequest = new ParseReferenceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ParseReferenceResponse$Type extends MessageType<ParseReferenceResponse> {
    constructor() {
        super("agency.reference.v1.ParseReferenceResponse", [
            { no: 1, name: "reference", kind: "message", T: () => Reference, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ParseReferenceResponse>): ParseReferenceResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ParseReferenceResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ParseReferenceResponse): ParseReferenceResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.reference.v1.Reference reference */ 1:
                    message.reference = Reference.internalBinaryRead(reader, reader.uint32(), options, message.reference);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ParseReferenceResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.reference.v1.Reference reference = 1; */
        if (message.reference)
            Reference.internalBinaryWrite(message.reference, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.reference.v1.ParseReferenceResponse
 */
export const ParseReferenceResponse = new ParseReferenceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BuildReferenceRequest$Type extends MessageType<BuildReferenceRequest> {
    constructor() {
        super("agency.reference.v1.BuildReferenceRequest", [
            { no: 1, name: "reference", kind: "message", T: () => Reference, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<BuildReferenceRequest>): BuildReferenceRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BuildReferenceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BuildReferenceRequest): BuildReferenceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.reference.v1.Reference reference */ 1:
                    message.reference = Reference.internalBinaryRead(reader, reader.uint32(), options, message.reference);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BuildReferenceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.reference.v1.Reference reference = 1; */
        if (message.reference)
            Reference.internalBinaryWrite(message.reference, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.reference.v1.BuildReferenceRequest
 */
export const BuildReferenceRequest = new BuildReferenceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BuildReferenceResponse$Type extends MessageType<BuildReferenceResponse> {
    constructor() {
        super("agency.reference.v1.BuildReferenceResponse", [
            { no: 1, name: "psref_uri", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "2048" } } } }
        ]);
    }
    create(value?: PartialMessage<BuildReferenceResponse>): BuildReferenceResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.psrefUri = "";
        if (value !== undefined)
            reflectionMergePartial<BuildReferenceResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BuildReferenceResponse): BuildReferenceResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string psref_uri */ 1:
                    message.psrefUri = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BuildReferenceResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string psref_uri = 1; */
        if (message.psrefUri !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.psrefUri);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.reference.v1.BuildReferenceResponse
 */
export const BuildReferenceResponse = new BuildReferenceResponse$Type();
